import React from 'react'
import { useEffect , useState } from 'react'
import Product from './Product';
import './productList.css'
import './Responsive.css'

const ProductsList = () => {
    const [products , setProducts]= useState([]);
    const [categories , setCategories] = useState([]);

    const productApi = "https://fakestoreapi.com/products"

    useEffect(() =>{
        fetch(productApi).then((res) => res.json()).then((data) =>setProducts(data));
        
    },[]);

    const getAll = () =>{
        fetch(productApi).then((res) => res.json()).then((data) =>setProducts(data));
    }

    const getCategories = (products) =>{
        fetch(`${productApi}/categories`).then((res) => res.json()).then((data) =>setCategories(data));

    }
    useEffect(()=>getCategories,[])

    const showByCategory= (catName)=>{
        fetch(`${productApi}/category/${catName}`).then((res) => res.json()).then((product) =>setProducts(product));
      }

    const searchHandeler = ()=>{
        const btn = document.getElementById('inputSearch');
        const keyword = btn.value.toLowerCase();
        fetch(productApi)
        .then((res) => res.json())
        .then((products) => {
        const filteredProducts = products.filter(
        (product) => product.title.toLowerCase().includes(keyword)
    );
      setProducts(filteredProducts);
    });
        // setProducts(products.filter(
        //     (product) => product.title.toLowerCase().includes(keyword)
        // ));
        
       
    }
  return (
    <>
    <div className='products-list'>
        <div className='text-center'>
        <div className='row'>
            <div className='d-flex justify-content-center align-items-center search-btn'>
                <button className='text-all' onClick={getAll}>All</button>
                <input type='search' id="inputSearch" placeholder='Search by category' aria-controls='search-input'
                onChange={searchHandeler}/>
               
                <button className='text-search' onClick={searchHandeler}>Search</button>
             
            </div>
            <div className='filters'>
                {categories.map((category)=>{
                   return (
                    <button key={category} onClick={()=>{showByCategory(category)}}>{category}</button>)
                })}
            </div>
        </div>
        
        
        <div className='container row-products row g-4'>
                {products.map((el)=>{
                return(
                    <div className='custom-col col-lg-3 col-sm-6  col-md-4 col-xsm-12' key={el.id}>
                        <Product product={el} showBtn={true}/>   
                    </div> 
                )
                }
                )
            }
            </div>
        </div>
    </div>
    </>
  )

}
export default ProductsList;